import styled from '@emotion/styled'

export const AuthPagesWrapepr = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const StyleAuthWrapper = styled.div`
  width: 500px;
`

// LoginPage Styles

// Wrapper for the entire auth section
export const AuthWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    align-items: flex-start;
    height: 80vh;
  }
`

export const AuthCard = styled.div`
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 480px;

  @media (max-width: 768px) {
    padding: 0 12px;
    display: flex;
    flex-direction: column;
  }
`

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 20px;
  height: 100%; /* Change min-height to height */
  position: relative;

  @media (max-width: 768px) {
    padding: 0px 0px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh; /* Change min-height to height */
  }
`

// Header section with logo and title
export const AuthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 36px;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 480px) {
    margin-bottom: 24px;
  }
`
export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%; /* Add this */

  form {
    display: flex;
    flex-direction: column;
    height: 100%; /* Make the form take full height */
    flex: 1; /* Make the form grow to fill space */
  }

  @media (max-width: 768px) {
    flex: 1;
    height: 100%;
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 70vh; /* Set a minimum height */
  }
`
export const FormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex: 0 1 auto; /* Don't grow, can shrink, auto basis */
  }
`

// Container for remember me and forgot password
export const RememberForgotContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: auto;

  @media (max-width: 768px) {
    margin-top: auto;
    padding-top: 20px;
    gap: 12px;
    position: sticky; /* Add this */
    bottom: 0; /* Add this */
  }
`

// Link for forgot password
export const ForgotPasswordLink = styled.button`
  background: none;
  border: none;
  color: #000;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  padding: 0;

  @media (max-width: 480px) {
    align-self: flex-end;
  }
`
